<div class="card">
    <div class="card-header">
        Employee Leave Management -Back
    </div>
    <div class="card-body">
        <div class="row m-1">
            <div class="col-md-2 px-1">
                <label class="Label">Branch:<span class="text-danger">*</span></label>
            </div>
            <div class="col-md-4 px-1">
                <ng-select name="branch" [items]="BranchMaster" bindLabel="BranchName" bindValue="BranchMasterID"
                    [(ngModel)]="BranchId" (change)=" onSelectChange('Branch'); ComboLoad('Client')"
                    placeholder="Select Branch">
                    <ng-option *ngFor="let segment of BranchMaster" [value]="segment.BranchMasterID">
                        {{ segment.BranchName }}
                    </ng-option>
                </ng-select>
            </div>
        </div>
        <div class="row m-1">
            <div class="col-md-2 px-1">
                <label class="Label">Year:<span class="text-danger">*</span></label>
            </div>
            <div class="col-md-4 px-1">
                <ng-select name="year" [items]="YearLoad" bindLabel="Year" bindValue="Year" [(ngModel)]="Year"
                    (change)="onSelectChange('Year')" placeholder="Select Year">
                    <ng-option *ngFor="let segment of YearLoad" [value]="segment.Year">
                        {{ segment.Year }}
                    </ng-option>
                </ng-select>
            </div>
        </div>
        <div class="row m-1">
            <div class="col-md-2 px-1">
                <label class="Label">Leave:<span class="text-danger">*</span></label>
            </div>
            <div class="col-md-4 px-1">
                <ng-select name="leavetype" [items]="LeaveTypes" bindLabel="LeaveName" bindValue="LeaveMasterID"
                    [(ngModel)]="LeaveMasterId" (change)=" onSelectChange('LeaveType');" placeholder="Select Leave">
                    <ng-option *ngFor="let segment of LeaveTypes" [value]="segment.LeaveMasterID">
                        {{ segment.LeaveName }}
                    </ng-option>
                </ng-select>
            </div>
            <div class="col-md-3 px-1">
                <button class="btn btn-sm btn-primary" name="submit" (click)="Load('S')">
                    <i class="bi bi-download" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Load':'Loading...'}}
                </button>
                <!-- &nbsp;&nbsp; <label for="file-upload" class="btn btn-sm btn-primary">
                    <i class="bi bi-cloud-upload-fill" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled ? 'Excel Data' : 'Loading...'}}
                </label>
                <input id="file-upload" type="file" style="display: none" (change)="handleFileInput($event)"> -->
            </div>
        </div>
        <div class="row m-1">
            <div class="col-md-2 px-1">
                <label class="Label">Employee Code:</label>
            </div>
            <div class="col-md-2 px-1">
                <input name="Employeecode" type="text" class="form-control" [(ngModel)]="EmpCode"
                    placeholder="Enter Employee Code" />
            </div>
            <div class="col-md-2 px-1">
                <button class="btn btn-sm btn-primary" name="add" (click)="OpenToSearch()">
                    <i class="bi bi-search" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Search to Add':'Loading...'}}
                </button>
            </div>
        </div>
        <div>
            <div class="card border-radius-0 mt-1 p-0">
                <div class="card-header">
                    Data
                </div>
                <div class="card-body p-1" style="overflow: auto;">
                    <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                        class="customeDatatable table table-bordered">
                        <thead class="table-light">
                            <tr>
                                <th scope="col">#</th>

                                <th scope="col" style="width: 10%;">Employee Code</th>
                                <th scope="col">Employee Name</th>
                                <th scope="col">Joining Date</th>
                                <th scope="col" style="width: 10%;">Opening Balance</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let site of EmployeeLeaveManagementData; let i = index">
                                <th scope="row">{{ i + 1 }}</th>
                                <td style="width: 10%;">{{ site['EmpCode'] }}</td>
                                <td>{{ site['EmployeeName'] }}</td>
                                <td>{{site['JoiningDate']}}</td>
                                <td style="width: 10%;">
                                    <input name="latitude{{i}}" placeholder="0" style="text-align: right;  "
                                        class="form-control" type="number" [(ngModel)]="site.OpeningBalance" />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
    <div class="card-footer">
        <div class="row">
            <div class="col">
                <div class="row">
                </div>
                <div class="row">
                </div>
            </div>
            <div class="col-auto">
                <button *ngIf="this.common.PageRight.IsEdit || this.common.PageRight.IsAdd"
                    class="btn btn-sm btn-primary" name="submit" (click)="Save()">
                    <i class="bi bi-save" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Save':'Loading...'}}
                </button>&nbsp;&nbsp;
                <button class="btn btn-sm btn-primary" name="sample" (click)="downloadExcel()">
                    <i class="bi bi-file-earmark-excel" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Sample':'Loading...'}}
                </button>&nbsp;&nbsp;
                <label *ngIf="this.common.PageRight.IsPrint" for="file-upload" class="btn btn-sm btn-primary">
                    <i class="bi bi-cloud-upload-fill" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled ? 'Excel Upload' : 'Loading...'}}
                </label>
                <input id="file-upload" type="file" style="display: none" (change)="handleFileInput($event)"
                    accept=".xls,.xlsx">
                &nbsp; &nbsp;<button class="btn btn-sm btn-primary" name="Viewuniform" (click)="Excel()">
                    <i class="bi bi-file-earmark-arrow-down" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Excel':'Loading...'}}
                </button>
            </div>
        </div>
    </div>
</div>